import React from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from "react-redux";
import Actions from '../redux/actions/index';
import ReactStars from "react-rating-stars-component";
import Constants from '../utils/Constants';
import AppLoader from '../utils/AppLoader';
import { toast } from 'react-toastify';
import PatientCallSession from '../utils/patientCallSession';

class Feedback extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            feedBack: '',
            customerRating: 0,
            encryptId: '',
            srm_ip_room: null,
            feedbackRoomId: null,
        }
    }
    componentDidMount() {
        let encryptId = localStorage.getItem("vendorId")
        let srm_ip_room = localStorage.getItem("srm_ip_room")
        let srm_ip_vendor_id = localStorage.getItem("srm_ip_vendor_id")
        const feedbackRoomId = PatientCallSession.getFeedbackRoomId()
            || this.props.getCustomerToken
            || null;
        this.setState({
            encryptId: encryptId,
            srm_ip_room: srm_ip_room,
            srm_ip_vendor_id: srm_ip_vendor_id,
            feedbackRoomId,
        })
        if (PatientCallSession.consumeSessionEndedMessage()) {
            toast.info(Constants.SESSION_ENDED || 'Session is ended');
        }
        // Drop any leftover call URL from history so Back never reopens the call page
        try {
            window.history.replaceState(null, '', window.location.href);
        } catch (e) {
            /* ignore */
        }
    }

    getFeedbackRoomId = () => {
        return this.state.feedbackRoomId
            || this.props.getCustomerToken
            || PatientCallSession.getFeedbackRoomId()
            || null;
    };

    getMainNavigation = () => {
        const { srm_ip_room, srm_ip_vendor_id, encryptId } = this.state;
        if (srm_ip_room && srm_ip_vendor_id) {
            return `/SRM_IP/patient/${srm_ip_vendor_id}`;
        }
        if (srm_ip_room) {
            return `/SRM_IP/custom/${srm_ip_room}?fromFeedback=1`;
        }
        return `/custom/${encryptId}`;
    };

    goToMain = () => {
        PatientCallSession.clearFeedbackRoomId();
        this.props.history.replace(this.getMainNavigation());
    };

    submitHandler = () => {
        const { feedBack, customerRating, srm_ip_room } = this.state;
        const customerRoomId = this.getFeedbackRoomId();
        if (!customerRoomId) {
            toast.info('Session details unavailable. Returning to home.');
            this.goToMain();
            return;
        }
        let params = {
            roomId: customerRoomId,
            ratings: customerRating,
            feedback: feedBack,
            srm_ip_room: srm_ip_room ? customerRoomId : null
        }
        this.props.feedBack(params, () => {
            this.goToMain();
        })
    }
    ratingChanged = (newRating) => {
        this.setState({ customerRating: newRating })
    };
    render() {
        const { isLoading } = this.props.feedBackLoader
        return (
            <div className='feedback-form'>
                {isLoading && <AppLoader />}
                <div className='feed-form-inputs'>
                    <div className="skipDiv">
                        <button type="button" className="skip btn btn-link p-0 border-0" onClick={this.goToMain}>
                            {Constants.SKIP}
                        </button>
                    </div>
                    <h1 className='feed-head'>{Constants.FEEDBACK}</h1>
                    <p className='feed-para'>
                        {Constants.FEEDBACK_HEADERS}
                    </p>
                    <h4 className='rate-text'>{Constants.RATE_YOUR_EXPERIENCE}</h4>
                    <div className='rating-stars'>
                        <ReactStars
                            count={5}
                            onChange={this.ratingChanged}
                            size={44}
                            isHalf={true}
                            emptyIcon={<i className="far fa-star"></i>}
                            halfIcon={<i className="fa fa-star-half-alt"></i>}
                            fullIcon={<i className="fa fa-star"></i>}
                            activeColor="#6B4A98"
                        />
                    </div>
                    <p className='commentsHeader'>{Constants.COMMMENT_OPTIONAL}</p>
                    <div className='d-grid gap-4 mt-4'>
                        <textarea className='form-control textarea-width' placeholder={Constants.YOUR_COMMENTS} onChange={(e) => this.setState({ feedBack: e.target.value })}></textarea>
                        <button className='btn send-btn' type='button' onClick={() => this.submitHandler()}>{Constants.SEND_FEEDBACK}</button>
                    </div>
                </div>
            </div>
        )
    }
}
export const mapStateToProps = (state) => {
    return {
        getCustomerToken: state?.CUSTOMER_LIST?.customerList?.response?.roomId,
        feedBackLoader: state?.FEEDBACK,
        getcutomerList: Actions.getcutomerList(state)
    }
};
export default withRouter(connect(mapStateToProps, {
    feedBack: Actions.feedBackAction
})(Feedback))
